"use strict";
/* Copyright (c) 2020 Ezzat Chamudi
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CJKsymbols = exports.KanaRanges = exports.CJKranges = void 0;
exports.CJKranges = [
    [0x4E00, 0x9FFF],
    [0x3400, 0x4DBF],
    [0x20000, 0x2A6DF],
    [0x2A700, 0x2B73F],
    [0x2B740, 0x2B81F],
    [0x2B820, 0x2CEAF],
    [0x2CEB0, 0x2EBEF],
    [0x30000, 0x3134F],
    [0xF900, 0xFAFF],
    [0x2F800, 0x2FA1F],
    [0x2E80, 0x2EFF],
];
exports.KanaRanges = [
    [0x3040, 0x309F],
    [0x30A0, 0x30FF],
    [0x31F0, 0x31FF],
];
exports.CJKsymbols = [
    [0x3000, 0x303F],
];
